// extracted by mini-css-extract-plugin
export default {"base":"SystemNotifications_base__mHtDY","cell":"SystemNotifications_cell__NAKEl"};